import APIController from '../core-api-controller';

export const fetchTypesApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/types${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const updateTypeDetail = (data, typeId = '') => {
  const path = `${APIController.endpointApi}/types/${typeId}`;
  return APIController.putCallback(path, data);
};
